export default __webpack_public_path__ + "static/media/1-2@2x.ca853881.png";